module.exports = __webpack_public_path__ + "static/img/nilfgaardian.2c08917.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nilfgaardian.png
// module id = mIJ7
// module chunks = 0